module.exports = "<app-aside-nav></app-aside-nav>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/volume_sfo2_01/www/html/lspcourier-dev/src/app/theme/pages/aside-left-minimize-default-enabled/aside-left-minimize-default-enabled.component.html
// module id = ../../../../../src/app/theme/pages/aside-left-minimize-default-enabled/aside-left-minimize-default-enabled.component.html
// module chunks = main